import React from "react";
import GOIHeaderSection from "../GOIHeaderSection";
import GOINode from "../GOINode";
import GOIRenderTabContent from "../GOIRenderTabContent";
import Tree from "../GOITree";
import useGOIFirstLevel from "./useGOIFirstLevel";
import useObjectInput from "../../../hooks/useObjectInput";
import "../index.css";

// component shows all the children in the same level
// Inside this component, all direct and indirect children nodes are shown on the same level
const GOIFirstLevel = ({ item, savingParentValue }) => {
  // consuming main context
  const { editingChildrenIds, treeViewIds, oneChildrenIsInEditMode } =
    useObjectInput();

  // custom hook for GOIFirstLevel
  const { activeTab, isSaving, onStateChange, handleSaveBtnClick, resetKey } =
    useGOIFirstLevel(item);

  return (
    <div
      className={"generated-object-input mx-15 mt-10"}
      id={`scroll-${item.id}`}
    >
      <GOIHeaderSection
        activeTab={activeTab}
        setActiveTab={(value) => onStateChange("activeTab", value)}
        saving={isSaving || savingParentValue}
        editMode={oneChildrenIsInEditMode(item.childrenIds)}
        data={item}
        handleSaveBtnClick={handleSaveBtnClick}
        showSwitchView={true}
        cancelAllowed={false}
        backToEditingAllowed={false}
      />
      {/* tab content viewer */}
      <GOIRenderTabContent activeTab={activeTab} data={item} />
      <div className={activeTab && "goi-input-field-wrapper-border-top"}>
        {!treeViewIds[item.id] ? (
          item.associatedObjects?.map((associatedObject, index) =>
            associatedObject.hasOwnProperty("savedValue") ? (
              <GOINode
                level={1}
                key={`${resetKey.current}-node-${index}`}
                inputData={associatedObject}
                savingParentValue={isSaving || savingParentValue}
                editMode={editingChildrenIds[associatedObject.id]}
              />
            ) : (
              <React.Fragment key={index}></React.Fragment>
            )
          )
        ) : (
          <Tree
            item={item}
            key={`${resetKey.current}-tree`}
            savingParentValue={isSaving || savingParentValue}
          />
        )}
      </div>
    </div>
  );
};

export default GOIFirstLevel;
